export class InvestigationWatcherEntity {
  public watchId!: string;
  public watcherUserId!: string;
  public watcherName!: string;
  public watchedOn!: string;
}
